
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.25 5.562H5.456l-.769-3.937a.938.938 0 00-.937-.75H0V2.75h2.981l3.582 18a.937.937 0 00.937.75h16.875v-1.875H8.269l-.769-3.75h16.875a.937.937 0 00.938-.731l1.875-8.438a.938.938 0 00-.938-1.144zM23.625 14H7.144L5.83 7.437h19.247L23.625 14z","fill":"#1F1F1F"}})])
          )
        }
      }
    